/* WideBeads – doplňky k Dawn (viz migration/theme-spec.md).
   Načítáno v layout/theme.liquid za custom.css.

   Limit množství na max 2 kusy – na detailu produktu i v košíku.
   POZOR: je to KLIENTSKÝ (měkký) limit. Nastaví max/data-max na quantity
   inputy (Dawn podle nich deaktivuje „+" a hlídá krok) a osekne ručně
   napsanou hodnotu. Tvrdé vynucení (např. přidání 2 ks dvakrát, vypnutý JS,
   přímé volání cart API) by vyžadovalo Shopify Function na validaci košíku. */
(function () {
  var MAX = 2;

  function cap(input) {
    if (!input) return;
    var existing = parseInt(input.getAttribute('max'), 10);
    // respektuj případný nižší max (např. z pravidel/skladu), jinak zastropuj na MAX
    var max = isNaN(existing) ? MAX : Math.min(existing, MAX);
    if (String(max) !== input.getAttribute('max')) {
      input.setAttribute('max', max);
    }
    input.dataset.max = max;
    if (parseInt(input.value, 10) > max) {
      input.value = max;
    }
  }

  function capAll(root) {
    (root || document).querySelectorAll('input.quantity__input').forEach(cap);
  }

  if (document.readyState !== 'loading') {
    capAll();
  } else {
    document.addEventListener('DOMContentLoaded', function () { capAll(); });
  }

  // osekni ručně napsanou hodnotu
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('quantity__input')) {
      cap(t);
    }
  });

  // znovu aplikuj po AJAX překreslení (košík / změna varianty)
  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        if (n.matches && n.matches('input.quantity__input')) cap(n);
        if (n.querySelectorAll) capAll(n);
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();

/* Diamantová mřížka – fade in každého diamantu po načtení jeho obrázku.
   CSS skrývá obrázky jen když je na .wb-dg třída .wb-dg--js (přidává JS),
   takže bez JS zůstanou viditelné. Už načtené (cache) obrázky se odhalí
   synchronně, aby neproblikly. */
(function () {
  function reveal(img) {
    img.classList.add('is-loaded');
  }

  function initGrid(grid) {
    grid.classList.add('wb-dg--js');
    grid.querySelectorAll('img.wb-dg__img').forEach(function (img) {
      if (img.complete && img.naturalWidth > 0) reveal(img);
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('.wb-dg').forEach(initGrid);
  }

  // load neprobublává → odchyt v capture fázi (i pro pozdě přidané obrázky)
  document.addEventListener(
    'load',
    function (e) {
      var t = e.target;
      if (t && t.classList && t.classList.contains('wb-dg__img')) reveal(t);
    },
    true
  );

  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  }

  // donačtené řady (infinite scroll) i nově vložené mřížky
  var dgmo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        if (n.classList && n.classList.contains('wb-dg')) initGrid(n);
        if (n.querySelectorAll) {
          n.querySelectorAll('.wb-dg').forEach(initGrid);
          n.querySelectorAll('img.wb-dg__img').forEach(function (img) {
            if (img.complete && img.naturalWidth > 0) reveal(img);
          });
        }
      }
    }
  });
  dgmo.observe(document.documentElement, { childList: true, subtree: true });
})();

/* Sidebar – po přidání do košíku (i jiné změně košíku) překreslit sekci
   sidebaru přes Section Rendering API, aby se tlačítko Košík + badge hned
   aktualizovaly. Reaguje na Dawn pub/sub událost cartUpdate. */
(function () {
  function sidebarWrap() {
    return document.querySelector('.wb-sidebar-section');
  }

  var pending = false;

  function refreshSidebar() {
    var wrap = sidebarWrap();
    if (!wrap || pending) return;
    var id = wrap.id.replace('shopify-section-', '');
    if (!id) return;
    pending = true;
    var url = window.location.pathname + '?section_id=' + encodeURIComponent(id);
    var cur = new URLSearchParams(window.location.search);
    if (cur.has('preview_theme_id')) {
      url += '&preview_theme_id=' + encodeURIComponent(cur.get('preview_theme_id'));
    }
    fetch(url)
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var fresh = sidebarWrap();
        if (fresh) fresh.innerHTML = html;
      })
      .catch(function (err) {
        console.warn('[wb-sidebar] aktualizace košíku selhala:', err);
      })
      .finally(function () {
        pending = false;
      });
  }

  function bind() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refreshSidebar);
    }
  }

  if (document.readyState !== 'loading') {
    bind();
  } else {
    document.addEventListener('DOMContentLoaded', bind);
  }
})();

/* Nezalomitelná mezera po „č." před číslem (např. „(č. 1239)") – aby se
   „č." a číslo nikdy nerozdělily na dva řádky. Řeší se v názvech produktu
   (detail) a v kartách kolekce/hledání; funguje i pro donačtené karty. */
(function () {
  var SEL = '.product__title, .card__heading';

  function fixText(node) {
    var v = node.nodeValue;
    if (!v || v.indexOf('č.') === -1) return;
    var nv = v.replace(/č\.[ \t ]*(?=\d)/g, 'č. ');
    if (nv !== v) node.nodeValue = nv;
  }

  function fixIn(root) {
    (root || document).querySelectorAll(SEL).forEach(function (el) {
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
      var n;
      while ((n = walker.nextNode())) fixText(n);
    });
  }

  if (document.readyState !== 'loading') {
    fixIn();
  } else {
    document.addEventListener('DOMContentLoaded', function () { fixIn(); });
  }

  var nbmo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        if (n.matches && n.matches(SEL)) {
          var w = document.createTreeWalker(n, NodeFilter.SHOW_TEXT, null);
          var t;
          while ((t = w.nextNode())) fixText(t);
        }
        if (n.querySelectorAll) fixIn(n);
      }
    }
  });
  nbmo.observe(document.documentElement, { childList: true, subtree: true });
})();

/* Vlastní lightbox detailu produktu – klik na hlavní obrázek galerie zobrazí
   jen ten jeden snímek ve zvětšenině (ne přes celou obrazovku; CSS řeší
   max ~75 % výšky). Zavře se klikem na pozadí/obrázek/křížek nebo Esc.
   Tlačítko „Zobrazit na virtuální modelce“ (snippets/wb-virt-button.liquid)
   otevře stejný lightbox s popiskem přes spodní okraj fotky. */
(function () {
  var overlay = null;

  function build() {
    if (overlay) return overlay;
    overlay = document.createElement('div');
    overlay.className = 'wb-lightbox';
    overlay.setAttribute('aria-hidden', 'true');
    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'wb-lightbox__close';
    close.setAttribute('aria-label', 'Zavřít');
    close.innerHTML = '&times;';
    var fig = document.createElement('figure');
    fig.className = 'wb-lightbox__fig';
    var img = document.createElement('img');
    img.className = 'wb-lightbox__img';
    img.alt = '';
    var cap = document.createElement('figcaption');
    cap.className = 'wb-lightbox__cap';
    cap.hidden = true;
    fig.appendChild(img);
    fig.appendChild(cap);
    overlay.appendChild(close);
    overlay.appendChild(fig);
    document.body.appendChild(overlay);
    overlay.addEventListener('click', closeLightbox);
    return overlay;
  }

  function setCaption(o, caption) {
    var cap = o.querySelector('.wb-lightbox__cap');
    cap.textContent = '';
    cap.hidden = !caption;
    if (!caption) return;
    var label = document.createElement('span');
    label.className = 'wb-lightbox__label';
    label.textContent = caption.label || '';
    var note = document.createElement('span');
    note.className = 'wb-lightbox__note';
    note.textContent = caption.note || '';
    cap.appendChild(label);
    cap.appendChild(note);
    if (!caption.url) return;
    var link = document.createElement('a');
    link.className = 'wb-lightbox__link';
    link.href = caption.url;
    link.textContent = 'Zobrazit šperk';
    cap.appendChild(link);
  }

  function openLightbox(src, alt, caption) {
    var o = build();
    var img = o.querySelector('.wb-lightbox__img');
    img.src = src;
    img.alt = alt || '';
    setCaption(o, caption);
    o.classList.add('is-open');
    o.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  }

  function closeLightbox() {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }

  function hiRes(img) {
    var s = img.currentSrc || img.src || '';
    return s.replace(/([?&]width=)\d+/, '$1' + 1600);
  }

  document.addEventListener('click', function (e) {
    var virt = e.target.closest ? e.target.closest('[data-wb-virt]') : null;
    if (virt) {
      e.preventDefault();
      openLightbox(virt.getAttribute('data-wb-virt'), virt.getAttribute('data-wb-virt-alt'), {
        label: virt.getAttribute('data-wb-virt-label'),
        note: virt.getAttribute('data-wb-virt-note'),
        url: virt.getAttribute('data-wb-virt-url'),
      });
      return;
    }
    var img = e.target.closest ? e.target.closest('.product__media-list img') : null;
    if (!img) return;
    if (img.closest('.thumbnail-list, deferred-media')) return;
    e.preventDefault();
    openLightbox(hiRes(img), img.alt, null);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeLightbox();
  });
})();

/* Stránka „Ukázky na modelce“ (sections/wb-virt-gallery.liquid) – Liquid
   vykreslí virt fotky z prvních 250 produktů; další stránky katalogu se tu
   dočtou a vše se seřadí podle čísla produktu (data-n, nejvyšší nahoře). */
(function () {
  var root = document.querySelector('.wb-vg');
  if (!root) return;
  var grid = root.querySelector('.wb-vg__grid');
  var pages = parseInt(root.getAttribute('data-pages'), 10) || 1;
  var current = parseInt(root.getAttribute('data-current'), 10) || 1;

  function finish() {
    var items = Array.prototype.slice.call(grid.children);
    items.sort(function (a, b) {
      return Number(b.getAttribute('data-n')) - Number(a.getAttribute('data-n'));
    });
    items.forEach(function (li) {
      grid.appendChild(li);
    });
    root.querySelector('.wb-vg__empty').hidden = items.length > 0;
  }

  if (current !== 1 || pages < 2) {
    finish();
    return;
  }

  var base = root.getAttribute('data-src');
  var requests = [];
  for (var p = 2; p <= pages; p++) {
    requests.push(
      fetch(base + '&page=' + p)
        .then(function (r) {
          return r.ok ? r.text() : '';
        })
        .then(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          doc.querySelectorAll('.wb-vg__grid > li').forEach(function (li) {
            grid.appendChild(document.importNode(li, true));
          });
        })
        .catch(function () {})
    );
  }
  Promise.all(requests).then(finish);
})();

/* Košík – fade in obrázků produktů po načtení (i po AJAX změně košíku).
   html.wb-cart-fade se přidá jen když jsou na stránce obrázky košíku, takže
   bez JS zůstanou viditelné; už načtené se odhalí synchronně (bez probliknutí). */
(function () {
  function reveal(img) {
    img.classList.add('is-loaded');
  }

  function sweep(root) {
    var imgs = (root || document).querySelectorAll('img.cart-item__image');
    if (!imgs.length) return;
    document.documentElement.classList.add('wb-cart-fade');
    imgs.forEach(function (img) {
      if (img.complete && img.naturalWidth > 0) reveal(img);
    });
  }

  document.addEventListener(
    'load',
    function (e) {
      var t = e.target;
      if (t && t.classList && t.classList.contains('cart-item__image')) reveal(t);
    },
    true
  );

  if (document.readyState !== 'loading') {
    sweep();
  } else {
    document.addEventListener('DOMContentLoaded', function () { sweep(); });
  }

  var cmo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        if (n.matches && n.matches('img.cart-item__image')) {
          if (n.complete && n.naturalWidth > 0) reveal(n);
        }
        if (n.querySelectorAll) sweep(n);
      }
    }
  });
  cmo.observe(document.documentElement, { childList: true, subtree: true });
})();

/* Mobilní sidebar (drawer) – hamburger otevře, backdrop/křížek/Esc/klik na
   odkaz zavře. Delegováno na document, aby fungovalo i po re-renderu sekce
   sidebaru (překreslení po změně košíku). */
(function () {
  function open() {
    var s = document.querySelector('.wb-sidebar');
    var b = document.querySelector('.wb-sidebar-backdrop');
    var t = document.querySelector('.wb-sidebar-toggle');
    if (s) s.classList.add('is-open');
    if (b) b.classList.add('is-open');
    if (t) t.setAttribute('aria-expanded', 'true');
    document.documentElement.style.overflow = 'hidden';
  }

  function close() {
    var s = document.querySelector('.wb-sidebar');
    var b = document.querySelector('.wb-sidebar-backdrop');
    var t = document.querySelector('.wb-sidebar-toggle');
    if (s) s.classList.remove('is-open');
    if (b) b.classList.remove('is-open');
    if (t) t.setAttribute('aria-expanded', 'false');
    document.documentElement.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('[data-wb-sidebar-open]')) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-wb-sidebar-close]')) { e.preventDefault(); close(); return; }
    if (e.target.closest('.wb-sidebar a')) close();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  window.addEventListener('resize', function () {
    if (window.innerWidth >= 990) close();
  });
})();

/* Zásilkovna – výběr výdejního místa (Packeta widget v6) v košíku.
   Markup je v sections/wb-zasilkovna.liquid (mezi položkami a patičkou
   košíku), styly v custom.css. Výběr z mapy se ukládá přes /cart/update.js
   jako atribut košíku „Výdejní místo Zásilkovny“ (Petra ho vidí u objednávky
   v adminu). Klik na Pokladna bez vybraného místa zobrazí měkký dotaz
   („Vybrat“ / „Pokračovat bez výběru“) – tvrdé vynucení v pokladně na plánu
   Basic nejde (zákazník volí dopravu až tam). */
(function () {
  var ATTR = 'Výdejní místo Zásilkovny';
  var WIDGET_SRC = 'https://widget.packeta.com/v6/www/js/library.js';
  var picked = null; // aktuální hodnota atributu (plní se z DOM při načtení)
  var skipConfirmed = false; // „Pokračovat bez výběru“ platí do reloadu stránky
  var modal = null;

  function root() {
    return document.querySelector('[data-wb-zas]');
  }

  function init() {
    var r = root();
    if (!r) return;
    var nameEl = r.querySelector('[data-wb-zas-name]');
    var v = nameEl && nameEl.textContent.trim();
    picked = v || null;
  }

  function setAttribute(value) {
    var attrs = {};
    attrs[ATTR] = value || '';
    // routes.cart_update_url je "/cart/update" (bez .js) → vrací redirect na
    // HTML košíku; JSON odpověď dává až přípona .js + Accept hlavička.
    var url = (window.routes && window.routes.cart_update_url) || '/cart/update';
    if (url.indexOf('.js') === -1) url += '.js';
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs }),
    }).then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.json();
    });
  }

  function updateUI() {
    var r = root();
    if (!r) return;
    var sel = r.querySelector('[data-wb-zas-selected]');
    var nameEl = r.querySelector('[data-wb-zas-name]');
    var pick = r.querySelector('[data-wb-zas-pick]');
    var clear = r.querySelector('[data-wb-zas-clear]');
    if (picked) {
      if (nameEl) nameEl.textContent = picked;
      if (sel) sel.hidden = false;
      if (pick) pick.textContent = 'Změnit výdejní místo';
      if (clear) clear.hidden = false;
    } else {
      if (sel) sel.hidden = true;
      if (pick) pick.textContent = 'Vybrat výdejní místo';
      if (clear) clear.hidden = true;
    }
  }

  /* Widget skript vkládá sekce; kdyby se nestihl načíst (nebo byl blokovaný),
     zkusí se donačíst a počká se na window.Packeta (max ~8 s). */
  function ensureWidget() {
    return new Promise(function (resolve, reject) {
      if (window.Packeta && window.Packeta.Widget) return resolve();
      if (!document.querySelector('script[src*="widget.packeta.com"]')) {
        var s = document.createElement('script');
        s.src = WIDGET_SRC;
        document.head.appendChild(s);
      }
      var waited = 0;
      var t = setInterval(function () {
        waited += 100;
        if (window.Packeta && window.Packeta.Widget) {
          clearInterval(t);
          resolve();
        } else if (waited >= 8000) {
          clearInterval(t);
          reject(new Error('Packeta widget se nenačetl'));
        }
      }, 100);
    });
  }

  function openWidget(apiKey) {
    ensureWidget()
      .then(function () {
        window.Packeta.Widget.pick(
          apiKey,
          function (point) {
            if (!point) return; // zavřeno bez výběru
            var label = point.name + ' (ID ' + point.id + ')';
            setAttribute(label)
              .then(function () {
                picked = label;
                updateUI();
              })
              .catch(function (err) {
                console.warn('[wb-zas] uložení výběru selhalo:', err);
                alert('Uložení výdejního místa se nepovedlo, zkuste to prosím znovu.');
              });
          },
          { country: 'cz', language: 'cs' }
        );
      })
      .catch(function (err) {
        console.warn('[wb-zas]', err);
        alert('Mapu výdejních míst se nepodařilo načíst. Zkuste to prosím znovu, případně napište název výdejního místa do poznámky.');
      });
  }

  function apiKey() {
    var r = root();
    var btn = r && r.querySelector('[data-wb-zas-pick]');
    return (btn && btn.getAttribute('data-wb-zas-api-key')) || '';
  }

  function buildModal() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.className = 'wb-zas-modal';
    modal.setAttribute('aria-hidden', 'true');
    modal.innerHTML =
      '<div class="wb-zas-modal__card" role="dialog" aria-modal="true" aria-label="Výdejní místo Zásilkovny">' +
      '<h3 class="wb-zas-modal__title">Doručení na výdejní místo?</h3>' +
      '<p>Chcete-li objednávku doručit na výdejní místo Zásilkovny, vyberte si ho prosím na mapě ještě před pokračováním do pokladny.</p>' +
      '<div class="wb-zas-modal__actions">' +
      '<button type="button" class="button" data-wb-zas-modal-pick>Vybrat výdejní místo</button>' +
      '<button type="button" class="wb-zas-modal__skip" data-wb-zas-modal-skip>Pokračovat bez výběru</button>' +
      '</div></div>';
    document.body.appendChild(modal);
    return modal;
  }

  function showModal() {
    var m = buildModal();
    m.classList.add('is-open');
    m.setAttribute('aria-hidden', 'false');
  }

  function hideModal() {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    var pickBtn = e.target.closest('[data-wb-zas-pick]');
    if (pickBtn) {
      e.preventDefault();
      openWidget(pickBtn.getAttribute('data-wb-zas-api-key'));
      return;
    }

    if (e.target.closest('[data-wb-zas-clear]')) {
      e.preventDefault();
      setAttribute('')
        .then(function () {
          picked = null;
          updateUI();
        })
        .catch(function (err) {
          console.warn('[wb-zas] zrušení výběru selhalo:', err);
        });
      return;
    }

    if (e.target.closest('[data-wb-zas-modal-pick]')) {
      hideModal();
      openWidget(apiKey());
      return;
    }

    if (e.target.closest('[data-wb-zas-modal-skip]')) {
      hideModal();
      skipConfirmed = true;
      var co = document.getElementById('checkout');
      if (co) co.click();
      return;
    }

    if (modal && e.target === modal) {
      hideModal();
      return;
    }

    // měkká pojistka před pokladnou (jen na stránce košíku se sekcí Zásilkovny)
    var checkout = e.target.closest('#checkout');
    if (checkout && root() && !picked && !skipConfirmed) {
      e.preventDefault();
      showModal();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') hideModal();
  });

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();

/* ⓘ rozcestník zásad v sidebaru – zavření klikem mimo, Esc nebo klikem na
   odkaz. Delegováno na document (přežije re-render sekce sidebaru). */
(function () {
  function closeInfo(except) {
    document.querySelectorAll('details.wb-sidebar__info[open]').forEach(function (d) {
      if (d !== except) d.removeAttribute('open');
    });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var d = e.target.closest('details.wb-sidebar__info');
    closeInfo(d);
    if (d && e.target.closest('.wb-sidebar__policies a')) closeInfo(null);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeInfo(null);
  });
})();

/* Popup Shopify Forms – vlastní 7denní pauza po zavření.
   Forms sám umí potlačit popup jen v rámci session (klíč
   `<formId>-dismissed-in-session` v localStorage, hodnota = id session
   z cookie _shopify_s, tj. po ~30 min neaktivity se popup ukáže znovu).
   Tady: když se takový klíč během návštěvy změní (= návštěvník popup
   zavřel), zapíšeme si vlastní časovou zámku a dalších 7 dní schováme
   celý embed kontejner Forms (popup i upoutávku) třídou na <html> –
   pravidlo je v custom.css. Po odeslání formuláře Forms popup skrývá
   sám navždy (jiný klíč `-dismissed-after-submit`, toho se nedotýkáme). */
(function () {
  var KEY = 'wb-popup-cooldown-until';
  var COOLDOWN = 7 * 24 * 60 * 60 * 1000;

  function get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

  var until = parseInt(get(KEY), 10);
  if (until && Date.now() < until) {
    document.documentElement.classList.add('wb-popup-cooldown');
    return; // popup je schovaný, není co hlídat
  }

  function snapshot() {
    var s = {};
    try {
      for (var i = 0; i < localStorage.length; i++) {
        var k = localStorage.key(i);
        if (k && /-dismissed-in-session$/.test(k)) s[k] = localStorage.getItem(k);
      }
    } catch (e) {}
    return s;
  }

  var before = snapshot();
  var timer = setInterval(function () {
    var now = snapshot();
    for (var k in now) {
      if (now[k] !== before[k]) {
        set(KEY, String(Date.now() + COOLDOWN));
        clearInterval(timer);
        return;
      }
    }
  }, 3000);
})();

/* Detail produktu – listování předchozí/další v kategorii (dokola).
   Markup je ve snippets/wb-product-nav.liquid. Pořadí produktů kategorie se
   načte z alternativní šablony templates/collection.wb-nav.liquid
   (/collections/<h>?view=wb-nav, 250 položek na stránku) a na 10 min se
   uloží do sessionStorage. Pak se doplní odkazy, náhledy a popisky šipek
   a odkryjí se šipky i spodní karty. Klávesy ← → přepínají produkty, pokud
   není otevřený lightbox/modal a kurzor není v poli formuláře.
   Když se načtení nepovede, zůstanou jen drobečky a odkaz na kategorii. */
(function () {
  var TTL = 10 * 60 * 1000;
  var nav = document.querySelector('[data-wb-pnav]');
  if (!nav) return;
  var cat = nav.getAttribute('data-category');
  var current = nav.getAttribute('data-product');
  var host = nav.closest('.wb-pnav-host') || document;
  var neighbours = null;

  function cacheGet() {
    try {
      var v = JSON.parse(sessionStorage.getItem('wb-pnav:' + cat));
      if (v && Date.now() - v.at < TTL) return v.items;
    } catch (e) {}
    return null;
  }

  function cacheSet(items) {
    try { sessionStorage.setItem('wb-pnav:' + cat, JSON.stringify({ at: Date.now(), items: items })); } catch (e) {}
  }

  function pageUrl(page) {
    var url = '/collections/' + encodeURIComponent(cat) + '?view=wb-nav&page=' + page;
    var cur = new URLSearchParams(window.location.search);
    if (cur.has('preview_theme_id')) url += '&preview_theme_id=' + encodeURIComponent(cur.get('preview_theme_id'));
    return url;
  }

  function fetchPage(page) {
    return fetch(pageUrl(page), { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.text();
    }).then(function (t) { return JSON.parse(t); });
  }

  function has(items, h) {
    for (var i = 0; i < items.length; i++) if (items[i].h === h) return true;
    return false;
  }

  function load() {
    var cached = cacheGet();
    // produkt v uloženém pořadí chybí (např. právě přidaný) → načíst znovu
    if (cached && has(cached, current)) return Promise.resolve(cached);
    return fetchPage(1).then(function (first) {
      var rest = [];
      for (var p = 2; p <= first.pages; p++) rest.push(fetchPage(p));
      return Promise.all(rest).then(function (more) {
        var items = first.items;
        more.forEach(function (m) { items = items.concat(m.items); });
        cacheSet(items);
        return items;
      });
    });
  }

  function fill(prev, next) {
    var map = { prev: prev, next: next };
    host.querySelectorAll('[data-wb-pnav-link]').forEach(function (a) {
      var dir = a.getAttribute('data-wb-pnav-link');
      var it = map[dir];
      a.href = it.u;
      a.setAttribute('aria-label', (dir === 'prev' ? 'Předchozí: ' : 'Další: ') + it.t);
    });
    host.querySelectorAll('[data-wb-pnav-title]').forEach(function (el) {
      el.textContent = map[el.getAttribute('data-wb-pnav-title')].t;
    });
    host.querySelectorAll('[data-wb-pnav-img]').forEach(function (img) {
      var it = map[img.getAttribute('data-wb-pnav-img')];
      if (it.i) img.src = it.i;
    });
    host.querySelectorAll('[data-wb-pnav-mini], [data-wb-pnav-side], [data-wb-pnav-cards]').forEach(function (el) {
      el.hidden = false;
    });
    place();
  }

  /* svislá poloha bočních šipek = střed hlavní fotky */
  function place() {
    var side = host.querySelector('[data-wb-pnav-side]');
    var media = host.querySelector('.product__media-list .product__media-item, .product__media-wrapper');
    if (!side || side.hidden || !media) return;
    var hostRect = host.getBoundingClientRect();
    var r = media.getBoundingClientRect();
    if (!r.height) return;
    side.style.setProperty('--wb-pnav-top', Math.round(r.top - hostRect.top + r.height / 2) + 'px');
  }

  load().then(function (items) {
    if (!items || items.length < 2) return;
    var idx = -1;
    for (var i = 0; i < items.length; i++) {
      if (items[i].h === current) { idx = i; break; }
    }
    if (idx < 0) return;
    var n = items.length;
    neighbours = { prev: items[(idx - 1 + n) % n], next: items[(idx + 1) % n] };
    fill(neighbours.prev, neighbours.next);
  }).catch(function (err) {
    console.warn('[wb-pnav] načtení pořadí kategorie selhalo:', err);
  });

  window.addEventListener('resize', place);
  window.addEventListener('load', place);

  document.addEventListener('keydown', function (e) {
    if (!neighbours || e.defaultPrevented) return;
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    if (e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return;
    var t = e.target;
    if (t && t.closest && t.closest('input, textarea, select, [contenteditable], slider-component, .slider, modal-dialog, product-modal')) return;
    if (document.querySelector('.wb-lightbox.is-open, product-modal[open], modal-dialog[open], .wb-zas-modal.is-open')) return;
    window.location.href = (e.key === 'ArrowLeft' ? neighbours.prev : neighbours.next).u;
  });
})();

/* Detail produktu (desktop od 990 px) – pokračovací šipka „↓ Další kousky“.
   Když karty předchozí/další (.wb-pbrowse; bez kategorie doporučené
   produkty) leží pod spodním okrajem obrazovky, ukáže se dole uprostřed
   cedulka; klik plynule posune stránku ke kartám. Po začátku rolování
   nebo když jsou karty vidět, zmizí a už se neukáže. Ikoně sdílení
   (custom.css ji na desktopu zmenší na ikonu) doplní bublinu „Sdílet“. */
(function () {
  var target = document.querySelector('.wb-pbrowse') || document.querySelector('product-recommendations');
  if (!target) return;
  var mq = window.matchMedia('(min-width: 990px)');
  var pill = null;
  var done = false;

  document.querySelectorAll('.product__info-container > share-button .share-button__button').forEach(function (b) {
    if (!b.title) b.title = 'Sdílet';
  });

  function visible() {
    return target.getBoundingClientRect().top < window.innerHeight - 24;
  }

  function hide() {
    done = true;
    if (pill) pill.classList.remove('is-shown');
    window.removeEventListener('scroll', onScroll);
  }

  function onScroll() {
    if (window.scrollY > 40 || visible()) hide();
  }

  function show() {
    if (pill || done || !mq.matches || window.scrollY > 40 || visible()) return;
    pill = document.createElement('button');
    pill.type = 'button';
    pill.className = 'wb-more';
    pill.innerHTML =
      '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M3 6l5 5 5-5"/></svg>' +
      '<span>Další kousky</span>';
    pill.addEventListener('click', function () {
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      hide();
    });
    document.body.appendChild(pill);
    requestAnimationFrame(function () {
      if (!done) pill.classList.add('is-shown');
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  // počkat, než se doplní karty a dorovná rozvržení (fotky, fonty); pojistka
  // 3 s – událost load se může zdržet na pomalém skriptu třetí strany
  var timer = setTimeout(show, 3000);
  window.addEventListener('load', function () {
    clearTimeout(timer);
    setTimeout(show, 600);
  });
})();
